import React from "react"
import FieldContainer, {
  InlineContainer,
} from "components/Form/FormFields/FieldParts/FieldContainer"
import Label from "components/Form/FormFields/FieldParts/Label"
import Input from "components/Form/FormFields/FieldParts/Input"
import TextArea from "components/Form/FormFields/FieldParts/TextArea"
import InputFeedback from "components/Form/FormFields/FieldParts/InputFeedback"

const TextInput = props => (
  <FieldContainer>
    <InlineContainer {...props}>
      <Label htmlFor={props.id} {...props}>
        {props.label}
      </Label>
      {props.type === "textarea" ? (
        <TextArea {...props} />
      ) : (
        <Input {...props} />
      )}
    </InlineContainer>
    <InputFeedback {...props} />
  </FieldContainer>
)

export default TextInput



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/TextInput/index.js